import { render } from "./ExtraDetails.vue?vue&type=template&id=6845e890&scoped=true"
import script from "./ExtraDetails.vue?vue&type=script&lang=js"
export * from "./ExtraDetails.vue?vue&type=script&lang=js"

import "./ExtraDetails.vue?vue&type=style&index=0&id=6845e890&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6845e890"]])

export default __exports__